<!-- 内包装标签备注 -->
<template>
  <BaseFormItem2
    class="label_remark"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseInput2
      v-model="val"
      width="186px"
      class="label_remark__input"
      placeholder="不超过10个文字, 或15个数字"
      @input="val => $emit('input', val)"
      @change="val => $emit('change', val)"
    ></BaseInput2>

    <BaseTipPopover 
      slot="other"
      placement="top"
      width="460px" 
      :content="`<img src='${require('@@/assets/img/pcb/label/label_remark.png')}' style='width: 100%;' />`"
    >
      <img 
        slot="reference" 
        class="label_remark__icon"
        :src="require('@@/assets/img/icons/icon_label.png')" 
      />
    </BaseTipPopover>
    
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('label_remark')
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.label_remark ::v-deep {
  .el-input__inner::placeholder {
    font-size: 12px;
  }
  .base-form-item__other {
    img {
      display: block;
      margin-top: 2px;
      width: 38px;
      height: 24px;
    }
  }
}
</style>